import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import 'Pages/SuperAdmin/Dashboard/dashboard.scss';
import rightArrow from 'assets/images/Dashboard/arrow-right.png';
import addIcon from 'assets/images/Dashboard/add.png';
import mail from 'assets/images/Dashboard/mail.png';
import call from 'assets/images/Dashboard/call.png';
import trash from 'assets/images/Dashboard/trash.png';
import { FormattedMessage, useIntl } from 'react-intl';
import ReusableButton from 'components/common/Button';
import {
  providerAdminAddBranches,
  providerAdminBranchesDetails,
} from 'routes/AppUrls';
import SwitchInput from 'components/common/Input/SwitchInput';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanyBranchProviderCallAPI } from 'store/ProviderAdmin/getCompanyBranchProvider/action';
import { deleteBranchProviderCallAPI } from 'store/ProviderAdmin/deleteBranchProvider/action';
import ToastNotification from 'components/common/Toast';
import { useConfirm } from 'material-ui-confirm';
import Lottie from 'lottie-react';
import animationData from 'assets/Lottie/no_data.json';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import InputAdornment from '@mui/material/InputAdornment';
import searchIcon from 'assets/images/navbar/search.svg';
import SelectInput from 'components/common/Input/SelectInput';
import crossIcon from 'assets/images/provider/crossIcon.png';
import { DateRangePicker } from 'react-date-range';
import { addDays } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style
import 'react-date-range/dist/theme/default.css'; // theme css
import CommonModal from 'components/common/Modal';
import { Box } from '@mui/system';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import moment from 'moment';
import { countryCityDropdownCallAPI } from 'store/CountryCityList/action';
import { getSearchBranchProviderCallAPI } from 'store/ProviderAdmin/getSearchBranchProvider/action';
import { updateProviderStatusCallAPI } from 'store/SuperAdmin/updateProviderStatus/action';
import { setPageTitle } from 'store/pageTitle/action';

const ProviderAdminBranches = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [conf, setConf] = ToastNotification();
  const { locale } = useContext(LocaleContext);
  const [checked, setChecked] = useState(false);
  const confirm = useConfirm();

  const [searchValue, setSearchValue] = useState('');
  const [selectSort, setSelectSort] = useState('');
  const [selectSortName, setSelectSortName] = useState('');
  const [selectSortOrder, setSelectSortOrder] = useState('');
  const [selectFilter, setSelectFilter] = useState('');
  const [selectFilterName, setSelectFilterName] = useState('All');
  const [selectCountry, setSelectCountry] = useState('');
  const [selectCity, setSelectCity] = useState('');
  const [isModalActive, setIsModalActive] = useState(false);

  const getBranchListData = useSelector(
    (state) => state?.getCompanyBranchProviderReducer?.data
  );

  const [branchListData, setbranchListData] = useState(
    getBranchListData?.data?.length > 0 ? getBranchListData?.data : []
  );

  const countryCityData = useSelector(
    (state) => state?.countryCityDropdownReducer?.data?.data
  );

  useEffect(() => {
    getBranchList();
    getCountryCityList();
  }, []);

  useEffect(() => {
    dispatch(setPageTitle('Branches'));
  }, []);

  const getCountryCityList = () => {
    dispatch(countryCityDropdownCallAPI({}, { naviagte: navigate }));
  };

  const getBranchList = () => {
    dispatch(
      getCompanyBranchProviderCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleSuccess = (res) => {
    setbranchListData(res?.data?.data);
  };

  const handleSwitchChange = (event, data) => {
    let body = {
      provider_id: data?.id,
      status: event?.target?.checked,
    };
    dispatch(
      updateProviderStatusCallAPI(body, {
        run: true,
        handleFunction: (res) => handleStatusSuccess(res),
        navigate: navigate,
      })
    );
  };

  const handleStatusSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    getBranchList();
  };

  const handleBranchDelete = (id) => {
    confirm({
      title: 'Confirm Delete',
      description: 'Are you sure you want to delete Branch ?',
      confirmationText: 'Yes',
      cancellationText: 'No',
      dialogProps: { maxWidth: 'xs' },
      confirmationButtonProps: {
        sx: {
          bgcolor: '#292D32',
          color: '#FFFFFF',
          borderRadius: '0px',
          border: '1px solid #292D32',
          '&:hover': { bgcolor: '#292D32' },
        },
      },
      cancellationButtonProps: {
        sx: {
          bgcolor: 'transparent',
          color: '#292D32',
          borderRadius: '0px',
          border: '1px solid #292D32',
        },
      },
    })
      .then(() => handleBranchConfirmDelete(id))
      .catch(() => console.log('Deletion cancelled.'));
  };

  const handleBranchConfirmDelete = (id) => {
    dispatch(
      deleteBranchProviderCallAPI(
        {},
        {
          id: id,
          run: true,
          handleFunction: (res) => handleDeleteSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleDeleteSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    getBranchList();
  };

  const handleSearch = (searchValues) => {
    setSearchValue(searchValues);
    if (searchValues === '') {
      getSearchProviderData(
        '',
        selectSort,
        selectSortOrder,
        selectFilter,
        selectCountry,
        selectCity,
        selectDateRange
      );
    } else {
      getSearchProviderData(
        searchValues,
        selectSort,
        selectSortOrder,
        selectFilter,
        selectCountry,
        selectCity,
        selectDateRange
      );
    }
  };

  const handleSearchClear = (name) => {
    switch (name) {
      case 'search':
        setSearchValue('');
        getSearchProviderData(
          '',
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'sort':
        setSelectSort('');
        setSelectSortName('');
        setSelectSortOrder('');
        getSearchProviderData(
          searchValue,
          '',
          '',
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'filter':
        setSelectFilter('');
        setSelectFilterName('All');
        getSearchProviderData(
          searchValue,
          selectSort,
          selectSortOrder,
          '',
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'country':
        setSelectCountry('');
        setSelectCity('');
        getSearchProviderData(
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          '',
          '',
          selectDateRange
        );
        break;
      case 'city':
        setSelectCity('');
        getSearchProviderData(
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          '',
          selectDateRange
        );
        break;
    }
  };

  const getSearchProviderData = (
    searchValue,
    searchSort,
    searchSortOrder,
    searchFilter,
    searchCountry,
    searchCity,
    selectDateRange
  ) => {
    let body = {
      search_text: searchValue,
      sort_by: searchSort,
      sort_order: searchSortOrder,
      status: searchFilter,
      country: searchCountry,
      city: searchCity,
      start_date: selectDateRange
        ? moment(selectDateRange?.[0]?.startDate)?.format('YYYY-MM-DD')
        : '',
      end_date: selectDateRange
        ? moment(selectDateRange?.[0]?.endDate)?.format('YYYY-MM-DD')
        : '',
    };
    dispatch(
      getSearchBranchProviderCallAPI(body, {
        run: true,
        handleFunction: (res) => handleSearchSuccess(res),
        navigate: navigate,
      })
    );
  };

  const handleSearchSuccess = (res) => {
    setbranchListData(res?.data?.data);
  };

  const getSortName = (name) => {
    switch (name) {
      case 'Name (A to Z)':
        return 'name';
      case 'Name (Z to A)':
        return 'name';
      case 'Join Date (Newest to Oldest)':
        return 'join_date';
      case 'Join Date (Oldest to Newest)':
        return 'join_date';
    }
  };

  const getSortOrder = (name) => {
    switch (name) {
      case 'Name (A to Z)':
        return 'asc';
      case 'Name (Z to A)':
        return 'desc';
      case 'Join Date (Newest to Oldest)':
        return 'desc';
      case 'Join Date (Oldest to Newest)':
        return 'asc';
    }
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case 'sort':
        setSelectSortName(value?.name);
        setSelectSort(getSortName(value?.name));
        setSelectSortOrder(getSortOrder(value?.name));
        getSearchProviderData(
          searchValue,
          getSortName(value?.name),
          getSortOrder(value?.name),
          selectFilter,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'filter':
        setSelectFilterName(value.name);
        let filterValue = '';
        if (value?.name?.includes('Active Status')) {
          filterValue = 'active';
        } else if (value?.name?.includes('Inactive Status')) {
          filterValue = 'inactive';
        } else {
          filterValue = '';
        }
        setSelectFilter(filterValue);
        getSearchProviderData(
          searchValue,
          selectSort,
          selectSortOrder,
          filterValue,
          selectCountry,
          selectCity,
          selectDateRange
        );
        break;
      case 'country':
        setSelectCountry(value?.name);
        getSearchProviderData(
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          value?.name,
          selectCity,
          selectDateRange
        );
        break;
      case 'city':
        setSelectCity(value?.name);
        getSearchProviderData(
          searchValue,
          selectSort,
          selectSortOrder,
          selectFilter,
          selectCountry,
          value?.name,
          selectDateRange
        );
        break;
    }
  };

  const getSortListData = [
    { name: 'Name (A to Z)' },
    { name: 'Name (Z to A)' },
    { name: 'Join Date (Newest to Oldest)' },
    { name: 'Join Date (Oldest to Newest)' },
  ];

  const getFilterCounts = () => {
    const activeCount =
      branchListData?.filter((item) => item?.status === true)?.length || 0;
    const inactiveCount =
      branchListData?.filter((item) => item?.status === false)?.length || 0;
    return { activeCount, inactiveCount };
  };

  const { activeCount, inactiveCount } = getFilterCounts();

  const getFilterListData = [
    { name: 'All', value: 'all' },
    { name: `Active Status (${activeCount})`, value: 'active' },
    { name: `Inactive Status (${inactiveCount})`, value: 'inactive' },
  ];

  const handleClearAll = () => {
    setSearchValue('');
    setSelectSort('');
    setSelectSortName('');
    setSelectSortOrder('');
    setSelectFilter('');
    setSelectFilterName('All');
    setSelectCountry('');
    setSelectCity('');
    setDateRangeState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    ]);
    setSelectDateRange('');
    setSelectedLabel('Today');
    getSearchProviderData('', '', '', '', '', '', '');
  };

  ///////////////////////////////////////////////DateRange////////////////

  const [dateRangeState, setDateRangeState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [selectedLabel, setSelectedLabel] = useState('Today');
  const [selectDateRange, setSelectDateRange] = useState('');

  const predefinedRanges = [
    {
      label: 'Today',
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
    },
    {
      label: 'Yesterday',
      range: () => {
        const yesterday = addDays(new Date(), -1);
        return { startDate: yesterday, endDate: yesterday };
      },
    },
    {
      label: 'Last 7 Days',
      range: () => ({
        startDate: addDays(new Date(), -6),
        endDate: new Date(),
      }),
    },
    {
      label: 'Last 30 Days',
      range: () => ({
        startDate: addDays(new Date(), -29),
        endDate: new Date(),
      }),
    },
    {
      label: 'This Month',
      range: () => {
        const now = new Date();
        return {
          startDate: new Date(now.getFullYear(), now.getMonth(), 1),
          endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0),
        };
      },
    },
    {
      label: 'Last Month',
      range: () => {
        const now = new Date();
        return {
          startDate: new Date(now.getFullYear(), now.getMonth() - 1, 1),
          endDate: new Date(now.getFullYear(), now.getMonth(), 0),
        };
      },
    },
  ];

  const handleCloseModel = () => {
    setIsModalActive(false);
  };
  ///////////////////////////////////////////////DateRange////////////////

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <div className="flex justify-between items-center">
          {/* <h2 className="fc-1A1A1A fs-32 fw-400 ff-Akkurat_Bold m-0">
            <FormattedMessage id="Branches" />
          </h2> */}

          <ReusableButton
            fullWidth={false}
            variant="contained"
            color="#F5F5F5"
            fontSize="16px"
            fontWeight="400"
            padding="12px"
            height="48px"
            bgColor="#1A1A1A"
            fontFamily="Akkurat"
            onClick={() =>
              navigate(providerAdminAddBranches(locale), {
                state: { value: 'add' },
              })
            }
          >
            <img
              src={addIcon}
              alt="icon"
              style={{ height: '24px', width: '24px' }}
              className="me-2"
            />
            <FormattedMessage id="Add Branch" />
          </ReusableButton>
        </div>

        <Row className="p-0 mt-3">
          <Col md={12} lg={4} xl={4} xxl={3}>
            <LabelWithInput
              placeholder={intl.formatMessage({
                id: 'Search',
              })}
              label={intl.formatMessage({
                id: 'Search',
              })}
              name="search"
              type="text"
              marginLabelTop="0"
              height="48"
              bgColor="#FFFFFF"
              value={searchValue}
              onChange={(e) => handleSearch(e?.target?.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Image
                      src={searchIcon}
                      alt="icon"
                      style={{ cursor: 'pointer' }}
                    />
                    {searchValue ? (
                      <Image
                        src={crossIcon}
                        alt="icon"
                        width={18}
                        height={18}
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSearchClear('search')}
                      />
                    ) : null}
                  </InputAdornment>
                ),
              }}
            />
          </Col>

          <Col md={12} lg={4} xl={4} xxl={2}>
            <SelectInput
              marginLabelTop={'0'}
              label={intl.formatMessage({
                id: 'Sort',
              })}
              placeholder={intl.formatMessage({
                id: 'Sort',
              })}
              height="48"
              name={'sort'}
              value={selectSortName}
              data={getSortListData ?? []}
              onChange={(e) => handleSelectChange(e)}
              InputProps={{
                endAdornment: selectSortName ? (
                  <InputAdornment
                    position="end"
                    sx={{ position: 'absolute', right: 5 }}
                  >
                    <Image
                      src={crossIcon}
                      alt="icon"
                      width={18}
                      height={18}
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleSearchClear('sort')}
                    />
                  </InputAdornment>
                ) : null,
              }}
            />
          </Col>

          <Col md={12} lg={4} xl={4} xxl={2}>
            <SelectInput
              marginLabelTop={'0'}
              label={intl.formatMessage({
                id: 'Filter',
              })}
              placeholder={intl.formatMessage({
                id: 'Filter',
              })}
              height="48"
              name={'filter'}
              value={selectFilterName}
              data={getFilterListData ?? []}
              onChange={(e) => handleSelectChange(e)}
              InputProps={{
                endAdornment:
                  selectFilterName !== 'All' ? (
                    <InputAdornment
                      position="end"
                      sx={{ position: 'absolute', right: 5 }}
                    >
                      <Image
                        src={crossIcon}
                        alt="icon"
                        width={18}
                        height={18}
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSearchClear('filter')}
                      />
                    </InputAdornment>
                  ) : null,
              }}
            />
          </Col>

          <Col md={12} lg={4} xl={4} xxl={2}>
            <SelectInput
              marginLabelTop={'0'}
              label={<FormattedMessage id="Country" />}
              placeholder={intl.formatMessage({ id: 'Country' })}
              height="48"
              name={'country'}
              value={selectCountry}
              data={countryCityData}
              onChange={(e) => handleSelectChange(e)}
              InputProps={{
                endAdornment: selectCountry ? (
                  <InputAdornment
                    position="end"
                    sx={{ position: 'absolute', right: 5 }}
                  >
                    <Image
                      src={crossIcon}
                      alt="icon"
                      width={18}
                      height={18}
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleSearchClear('country')}
                    />
                  </InputAdornment>
                ) : null,
              }}
            />
          </Col>

          <Col md={12} lg={4} xl={4} xxl={2}>
            <SelectInput
              marginLabelTop={'0'}
              label={<FormattedMessage id="City" />}
              placeholder={intl.formatMessage({ id: 'City' })}
              height="48"
              name={'city'}
              value={selectCity}
              data={
                countryCityData?.find((value) => value?.name === selectCountry)
                  ?.city || []
              }
              onChange={(e) => handleSelectChange(e)}
              InputProps={{
                endAdornment: selectCity ? (
                  <InputAdornment
                    position="end"
                    sx={{ position: 'absolute', right: 5 }}
                  >
                    <Image
                      src={crossIcon}
                      alt="icon"
                      width={18}
                      height={18}
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleSearchClear('city')}
                    />
                  </InputAdornment>
                ) : null,
              }}
            />
          </Col>

          {(searchValue ||
            selectSort ||
            selectFilter ||
            selectCountry ||
            selectCity ||
            selectDateRange ||
            selectFilterName !== 'All') && (
            <Col md={12} lg={4} xl={4} xxl={1} className="mt-4">
              <ReusableButton
                fullWidth={true}
                variant="contained"
                color="#F5F5F5"
                fontSize="16px"
                fontWeight="400"
                padding="12px"
                height="48px"
                bgColor="#292D32"
                fontFamily="Akkurat"
                onClick={() => handleClearAll()}
              >
                <FormattedMessage id="Clear All" />
              </ReusableButton>
            </Col>
          )}
        </Row>

        <Row className="p-0 mt-3">
          <Col md={12} lg={4} xl={4} xxl={3}>
            <LabelWithInput
              placeholder={intl.formatMessage({
                id: 'Date Range Filter',
              })}
              label={intl.formatMessage({
                id: 'Date Range Filter',
              })}
              name="dateRange"
              type="text"
              marginLabelTop="0"
              height="48"
              bgColor="#FFFFFF"
              value={
                selectDateRange?.length > 0 &&
                moment(selectDateRange?.[0]?.startDate).isValid() &&
                moment(selectDateRange?.[0]?.endDate).isValid()
                  ? `${moment(selectDateRange[0].startDate).format('YYYY-MM-DD')} - ${moment(selectDateRange[0].endDate).format('YYYY-MM-DD')}`
                  : ''
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <CalendarMonthIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => setIsModalActive(true)}
                    />
                    {selectDateRange ? (
                      <Image
                        src={crossIcon}
                        alt="icon"
                        width={18}
                        height={18}
                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                        onClick={() => {
                          setDateRangeState([
                            {
                              startDate: new Date(),
                              endDate: new Date(),
                              key: 'selection',
                            },
                          ]);
                          setSelectDateRange('');
                          setSelectedLabel('Today');
                          getSearchProviderData(
                            searchValue,
                            selectSort,
                            selectSortOrder,
                            selectFilter,
                            selectCountry,
                            selectCity,
                            ''
                          );
                        }}
                      />
                    ) : null}
                  </InputAdornment>
                ),
              }}
            />
          </Col>
        </Row>

        <Row className="mt-3 listHeader m-0 p-0 flex items-center">
          <Col lg={3} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-1A1A1A ff-Akkurat_Bold">
              <FormattedMessage id="Branch" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-1A1A1A ff-Akkurat_Bold">
              <FormattedMessage id="Branch Manager" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-1A1A1A ff-Akkurat_Bold">
              <FormattedMessage id="Contact Info" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-1A1A1A ff-Akkurat_Bold">
              <FormattedMessage id="Joined On" />
            </p>
          </Col>
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-1A1A1A ff-Akkurat_Bold">
              <FormattedMessage id="Status" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-1A1A1A ff-Akkurat_Bold">
              <FormattedMessage id="Actions" />
            </p>
          </Col>
        </Row>

        <Row className="bc-FFFFFF m-0 p-0">
          {branchListData?.length > 0 ? (
            branchListData.map((key, index) => (
              <Row className="m-0 p-0 flex items-center listAppointment">
                <Col lg={3} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-1A1A1A fw-400 ff-Akkurat_Bold">
                    {key?.searched_business_name_en}
                  </p>
                  <p className="p-0 m-0 fs-12 fw-400 fc-1A1A1A ff-Akkurat">
                    {key?.address}
                  </p>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fc-1A1A1A fw-400 ff-Akkurat mt-1">
                    {key?.branch_manager_name_en}
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center "
                  >
                    <img
                      src={mail}
                      alt="icon"
                      style={{ height: '20px', width: '20px' }}
                    />
                    <p className="p-0 m-0 fs-12 fc-1A1A1A fw-400 ff-Akkurat">
                      {key?.email}
                    </p>
                  </Stack>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center mt-2"
                  >
                    <img
                      src={call}
                      alt="icon"
                      style={{ height: '20px', width: '20px' }}
                    />
                    <p className="p-0 m-0 fs-12 fc-1A1A1A fw-400 ff-Akkurat">
                      {key?.contact_number}
                    </p>
                  </Stack>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fc-1A1A1A fw-400 ff-Akkurat">
                    {key?.joining_on
                      ? moment(key?.joining_on)?.format('DD MMM YYYY')
                      : ''}
                  </p>
                </Col>

                <Col lg={1} md={6} sm={12} className="flex justify-center">
                  <SwitchInput
                    label={true}
                    checked={key?.status}
                    onChange={(e) => handleSwitchChange(e, key)}
                    color="secondary"
                  />
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center cursor-pointer"
                  >
                    <img
                      src={trash}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      onClick={() => handleBranchDelete(key?.id)}
                    />
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                      onClick={() =>
                        navigate(providerAdminBranchesDetails(locale), {
                          state: key?.id,
                        })
                      }
                    >
                      <p className="p-0 m-0 fs-14 fc-1A1A1A fw-400 ff-Akkurat_Bold underline underline-offset-4">
                        <FormattedMessage id="View Details" />
                      </p>
                      <img
                        src={rightArrow}
                        alt="icon"
                        style={{ height: '20px', width: '20px' }}
                      />
                    </Stack>
                  </Stack>
                </Col>
              </Row>
            ))
          ) : (
            <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
              <Lottie
                animationData={animationData}
                loop={true}
                style={{ height: '200px', width: '200px' }}
              />
            </Row>
          )}
        </Row>
      </Col>

      {/* DateRange Select Modal*/}
      <CommonModal
        padding={'32px 48px'}
        width={'800px'}
        modalActive={isModalActive}
        handleClose={() => handleCloseModel()}
        innerContent={
          <Box>
            <Row>
              <DateRangePicker
                className="
                [&_.rdrDateInput_input::placeholder]:text-gray-400
                [&_.rdrDateInput_input]:text-[#1A1A1A]
                [&_.rdrDayToday_.rdrDayNumber_span:after]:bg-[#000000]
                "
                ranges={dateRangeState}
                onChange={(item) => {
                  setDateRangeState([item.selection]);
                  const selected = predefinedRanges.find(
                    (range) =>
                      range.range().startDate.toDateString() ===
                        item.selection.startDate.toDateString() &&
                      range.range().endDate.toDateString() ===
                        item.selection.endDate.toDateString()
                  );
                  setSelectedLabel(selected?.label || '');
                }}
                staticRanges={predefinedRanges.map((range) => ({
                  label: range.label,
                  range: range.range,
                  isSelected() {
                    return selectedLabel === range.label;
                  },
                }))}
                inputRanges={[]}
                rangeColors={['#292D32']}
              />

              <Stack
                direction="horizontal"
                gap={3}
                className="items-center cursor-pointer flex justify-end"
              >
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#292D32"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="transparent"
                  fontFamily="Akkurat"
                  onClick={() => setIsModalActive(false)}
                >
                  <FormattedMessage id="Cancel" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#292D32"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="transparent"
                  fontFamily="Akkurat"
                  onClick={() => {
                    setDateRangeState([
                      {
                        startDate: new Date(),
                        endDate: new Date(),
                        key: 'selection',
                      },
                    ]);
                    setSelectedLabel('Today');
                    setSelectDateRange([
                      {
                        startDate: new Date(),
                        endDate: new Date(),
                        key: 'selection',
                      },
                    ]);
                    getSearchProviderData(
                      searchValue,
                      selectSort,
                      selectSortOrder,
                      selectFilter,
                      selectCountry,
                      selectCity,
                      [
                        {
                          startDate: new Date(),
                          endDate: new Date(),
                          key: 'selection',
                        },
                      ]
                    );
                  }}
                >
                  <FormattedMessage id="Clear" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="#292D32"
                  fontFamily="Akkurat"
                  onClick={() => {
                    setSelectDateRange(dateRangeState);
                    setIsModalActive(false);
                    getSearchProviderData(
                      searchValue,
                      selectSort,
                      selectSortOrder,
                      selectFilter,
                      selectCountry,
                      selectCity,
                      dateRangeState
                    );
                  }}
                >
                  <FormattedMessage id="Apply" />
                </ReusableButton>
              </Stack>
            </Row>
          </Box>
        }
      />
      {/* DateRange Select Modal  */}
    </Row>
  );
};

export default ProviderAdminBranches;
